import { AIDiscoveryEngine } from "#components/AIDiscoveryEngine";
import { ROICalculator } from "#components/ROICalculator";
import {
    Box,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import { FaCalculator, FaRobot } from "react-icons/fa/index.js";

export const CommandCenter: React.FC = () => {
    const bgContainer = useColorModeValue("whiteAlpha.900", "blackAlpha.800");
    const borderColor = useColorModeValue("whiteAlpha.500", "whiteAlpha.200");
    const tabSelectedBg = useColorModeValue("blue.50", "whiteAlpha.200");
    const tabSelectedColor = useColorModeValue("blue.600", "blue.200");

    return (
        <Box
            w="full"
            maxW={{ base: "full", lg: "500px" }}
            bg={bgContainer}
            backdropFilter="blur(20px)"
            borderRadius="2xl"
            boxShadow="2xl"
            border="1px solid"
            borderColor={borderColor}
            overflow="hidden"
        >
            <Tabs isFitted variant="enclosed" colorScheme="blue">
                <TabList
                    borderBottom="1px solid"
                    borderColor={borderColor}
                    bg={useColorModeValue("gray.50", "gray.900")}
                >
                    <Tab
                        _selected={{ color: tabSelectedColor, bg: tabSelectedBg, borderColor: borderColor, borderBottomColor: "transparent" }}
                        fontWeight="bold"
                        py={4}
                    >
                        <FaRobot style={{ marginRight: "8px" }} /> AI Advisor
                    </Tab>
                    <Tab
                        _selected={{ color: tabSelectedColor, bg: tabSelectedBg, borderColor: borderColor, borderBottomColor: "transparent" }}
                        fontWeight="bold"
                        py={4}
                    >
                        <FaCalculator style={{ marginRight: "8px" }} /> ROI Calculator
                    </Tab>
                </TabList>

                <TabPanels>
                    <TabPanel p={0}>
                        <AIDiscoveryEngine />
                    </TabPanel>
                    <TabPanel p={0} bg={useColorModeValue("white", "gray.800")}>
                        <ROICalculator />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
};
